import type {
  SyncFetchEventsParams,
  SyncFetchEventsResponse,
  SyncValidateParams,
  SyncValidateResponse
} from '@/lib/sync'

import BaseProxy from './Proxy.js'

class SyncProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/v12/sync/v1', parameters)
  }

  validate(params: SyncValidateParams): Promise<SyncValidateResponse> {
    return this.submit('post', 'sync/v1/validate', params)
  }

  sync(params: SyncFetchEventsParams): Promise<SyncFetchEventsResponse> {
    return this.submit('get', 'sync/v1/sync', { params })
  }
}

export default SyncProxy
